import { Attributes, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';

export default class IssuerPaymentScheduleCriteria extends Model.CriteriaBase {
    static typeName = "IssuerPaymentScheduleCriteria";

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    public issuerInvestmentId: number = 0;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = null;

    // Client only properties / methods

    @Attributes.NoTracking()
    public issuerInvestmentName: string = "";

    protected static addBusinessRules(rules: Validation.Rules<IssuerPaymentScheduleCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Issuer Payment Schedule Criteria";
    }
}